"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    AriaLive: function() {
        return _AriaLive.AriaLive;
    },
    ariaLiveClassNames: function() {
        return _useAriaLiveStylesstyles.ariaLiveClassNames;
    },
    renderAriaLive_unstable: function() {
        return _renderAriaLive.renderAriaLive_unstable;
    },
    useAriaLiveStyles_unstable: function() {
        return _useAriaLiveStylesstyles.useAriaLiveStyles_unstable;
    },
    useAriaLive_unstable: function() {
        return _useAriaLive.useAriaLive_unstable;
    }
});
const _AriaLive = require("./AriaLive");
const _renderAriaLive = require("./renderAriaLive");
const _useAriaLive = require("./useAriaLive");
const _useAriaLiveStylesstyles = require("./useAriaLiveStyles.styles");
